type KlaviyoEvent = {
  event: string;
  properties?: Record<string, unknown>;
  metricId?: string;
};

type KlaviyoIdentity = {
  email: string;
  properties?: Record<string, unknown>;
};

export const KLAVIYO_METRIC_IDS = {
  SignIn: '',
  SignUp: '',
} as const;

export const trackKlaviyoIdentity = ({
  email,
  properties,
}: KlaviyoIdentity) => {
  const klaviyo = (window as any).klaviyo;
  const learnq = (window as any)._learnq;

  if (klaviyo && typeof klaviyo.identify === 'function') {
    klaviyo.identify({ email, ...(properties ?? {}) });
    return;
  }

  if (klaviyo && typeof klaviyo.push === 'function') {
    klaviyo.push(['identify', { email, ...(properties ?? {}) }]);
    return;
  }

  if (learnq && typeof learnq.push === 'function') {
    learnq.push(['identify', { $email: email, ...(properties ?? {}) }]);
  }
};

export const trackKlaviyoEvent = ({
  event,
  properties,
  metricId,
}: KlaviyoEvent) => {
  const klaviyo = (window as any).klaviyo;
  const learnq = (window as any)._learnq;

  const payload = { ...(properties ?? {}) };
  if (metricId) {
    payload.metric_id = metricId;
  }

  if (klaviyo && typeof klaviyo.track === 'function') {
    klaviyo.track(event, payload);
    return;
  }

  if (klaviyo && typeof klaviyo.push === 'function') {
    klaviyo.push(['track', event, payload]);
    return;
  }

  if (learnq && typeof learnq.push === 'function') {
    learnq.push(['track', event, payload]);
  }
};
